import { useState } from "react";
import { useSelector } from "react-redux";
import { botConversationsList, supportConversationsList } from "units/chatbot/services/chatService";

export const useConversations = (selectedItem) => {
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [senderPhone, setSenderPhone] = useState([])
    const { accessToken } = useSelector((state => state.auth))
    const loadConversations = async (selectedMenu) => {
        try {
            setLoading(true)
            let data;
            if (selectedMenu === "supportBot") {
                selectedItem === "RayaBot"
                    ? data = await botConversationsList(accessToken)
                    : data = await supportConversationsList(accessToken);
            } else if (selectedMenu === "adminSupportBot") {
                data = await supportConversationsList(accessToken);
            } else {
                setError(" لیست گفتگوهای مورد نظر یافت نشد ");
                return;
            }
            if (data?.ok) {
                setLoading(false)
                if (selectedMenu === "supportBot" && selectedItem === "supportBot") {
                    setConversations(data.data.filter(e => e.withGPT !== true));
                } else {
                    setConversations(data?.data);
                }
                setError(null);
                if (selectedMenu === "supportBot") {
                    if (selectedItem === "RayaBot") {
                        const extractedPhones = data?.data
                            ?.map(e => e?.sender?.phone)
                        setSenderPhone(extractedPhones);

                    }
                }
            } else {
                setError("مشکلی در دریافت مکالمات پیش آمد");
            }
        } catch (error) {
            console.error(error);
            setError("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
        }finally{
            setLoading(false)
        }
    };

    return { conversations, error, loadConversations, senderPhone ,loading};
};
